import { Capacitor } from "@capacitor/core";
import { ReactNode, lazy } from "react";

import Suspense from "components/shared/Suspense";
import LoadingSpinner from "hardcover-ui/components/LoadingSpinner";

const PullToRefreshNative = lazy(() => import("./PullToRefreshNative"));

export default function PullToRefresh({ children }: { children: ReactNode }) {
  if (!Capacitor.isNativePlatform()) {
    return <>{children}</>;
  }

  return (
    <Suspense fallback={<LoadingSpinner variant="layout" size="lg" />}>
      <PullToRefreshNative>{children}</PullToRefreshNative>
    </Suspense>
  );
}
